export default "__VITE_ASSET__Dsv4Dv2o__"